import { default as lunarSignsTypes } from "./types";

const {
  FETCH_LUNAR_SIGNS_REQUEST,
  FETCH_LUNAR_SIGNS_SUCCESS,
  FETCH_LUNAR_SIGNS_FAILURE,
} = lunarSignsTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LUNAR_SIGNS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_LUNAR_SIGNS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_LUNAR_SIGNS_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
